import React from 'react';
import useSellToCustomer from './hooks/useSellToCustomer';
import SellToCustomerForm from './components/SellToCustomerForm';

const SellToCustomerPage = () => {
    const props = useSellToCustomer();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>{props.th('vehicleSalesSellToCustomer.pageTitle')}</h3>
            </div>

            <SellToCustomerForm {...props} />
        </div>
    );
};

export default SellToCustomerPage;
